import React from "react";
import styles from "./PrivacyPolicyPage.module.scss";

import Footer from '../../components/Footer/Footer';

const PrivacyPolicy = () => {
  return (
    <>
        <div className={styles.container}>
            <div className={styles.content}>
                <h1>Datenschutzerklärung</h1>
                <hr />
                <p>
                    Wir legen großen Wert auf den Schutz Ihrer personenbezogenen Daten. 
                    Diese Datenschutzerklärung erklärt, wie wir Ihre Informationen erfassen, nutzen und schützen.
                </p>

                <h2>1. Erfasste Daten</h2>
                <p>Wir erfassen die folgenden Daten:</p>
                <ul>
                    <li>Benutzername (kann für andere Nutzer in der allgemeinen Spielrangliste sichtbar sein)</li>
                    <li>E-Mail-Adresse</li>
                    <li>Postleitzahl (ausschließlich zu statistischen Zwecken verwendet)</li>
                </ul>

                <h2>2. Rechtsgrundlage für die Verarbeitung</h2>
                <p>
                    Die Verarbeitung Ihrer personenbezogenen Daten basiert auf folgenden rechtlichen Grundlagen:
                </p>
                <ul>
                    <li>Vertragserfüllung, wenn Sie unseren Dienst nutzen.</li>
                    <li>Berechtigtes Interesse an der Anzeige der allgemeinen Spielrangliste.</li>
                </ul>

                <h2>3. Dauer der Datenspeicherung</h2>
                <p>
                    Ihre personenbezogenen Daten werden für einen Zeitraum von <strong>3 Jahren</strong>&nbsp;
                    nach Ihrer letzten Aktivität auf unserem Dienst gespeichert. <br/>Nach Ablauf dieser Frist werden sie gelöscht.
                </p>

                <h2>4. Nutzung der Daten</h2>
                <p>Wir verwenden Ihre Daten ausschließlich für:</p>
                <ul>
                    <li>Gewährleistung des ordnungsgemäßen Betriebs des Dienstes</li>
                    <li>Ermöglichung der Anmeldung</li>
                    <li>Erstellung von Spielstatistiken und einer allgemeinen Spielrangliste (nur Anzeige des Benutzernamens)</li>
                    <li>Die geografische Verteilung der Spieler zu analysieren (anhand der Postleitzahl, anonym)</li>
                </ul>

                <h2>5. Schutz Ihrer Daten</h2>
                <p>
                    Wir setzen angemessene technische und organisatorische Maßnahmen ein, um 
                    Ihre Informationen vor unbefugtem Zugriff, Veränderung, Offenlegung oder Zerstörung zu schützen.
                    Diese Maßnahmen umfassen die Verschlüsselung von Daten und strenge Zugriffskontrollen.
                </p>

                <h2>6. Ihre Rechte</h2>
                <p>
                    Gemäß der DSGVO haben Sie die folgenden Rechte:
                </p>
                <ul>
                    <li>Recht auf Auskunft: Sie können eine Kopie Ihrer Daten erhalten.</li>
                    <li>Recht auf Berichtigung: Sie können Ihre Informationen korrigieren.</li>
                    <li>Recht auf Löschung: Sie können die Löschung Ihrer Daten verlangen.</li>
                    <li>Recht auf Datenübertragbarkeit: Sie können Ihre Daten in einem strukturierten Format erhalten.</li>
                    <li>Recht auf Einschränkung der Verarbeitung: Unter bestimmten Bedingungen können Sie die Einschränkung der Nutzung Ihrer Daten verlangen.</li>
                </ul>
                <p>
                    Um diese Rechte auszuüben, kontaktieren Sie uns unter folgender Adresse:&nbsp;
                    <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a>.
                </p>

                <h2>7. Beschwerde bei der CNIL</h2>
                <p>
                    Wenn Sie der Meinung sind, dass Ihre Rechte nicht eingehalten werden, können Sie eine Beschwerde 
                    bei der CNIL (Commission Nationale de l'Informatique et des Libertés) auf deren offizieller Website einreichen:
                    <a className={styles.link} href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer"> www.cnil.fr</a>.
                </p>

                <h2>8. Datenübertragung außerhalb der EU</h2>
                <p>
                    Ihre Daten werden innerhalb der Europäischen Union gespeichert. Es erfolgt keine Übertragung außerhalb der EU. Ihre Daten werden nicht an Dritte weitergegeben.
                </p>
            </div>
        </div>

        <Footer/>
    </>
  );
};

export default PrivacyPolicy;
